import React from 'react';
import { CalendarCheck, Search, Sparkles, HeartHandshake } from 'lucide-react';

const STEPS = [
  { num: '01', Icon: CalendarCheck, title: 'Book Inspection', desc: 'Schedule online or call us — 60-second booking.' },
  { num: '02', Icon: Search, title: 'Site Evaluation', desc: 'Expert assessment of your property and infestation.' },
  { num: '03', Icon: Sparkles, title: 'Treatment Execution', desc: 'Safe, eco-friendly treatment by certified pros.' },
  { num: '04', Icon: HeartHandshake, title: 'Follow-up Support', desc: 'Free re-visits + dedicated WhatsApp support.' },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-brand-blue via-brand-blue-light to-brand-blue text-white overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '40px 40px' }} />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-16">
          <span className="inline-block text-xs sm:text-sm font-semibold uppercase tracking-wider text-brand-green-light">How It Works</span>
          <h2
            className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold"
            style={{ fontFamily: 'Poppins, Inter, sans-serif' }}
            data-testid="how-title"
          >
            Get Pest-Free in 4 Simple Steps
          </h2>
          <p className="mt-3 text-base text-white/80">Hassle-free booking, transparent process, lifetime support.</p>
        </div>

        <div className="relative">
          {/* Desktop horizontal line */}
          <div aria-hidden className="hidden lg:block absolute left-0 right-0 top-9 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent" />

          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 relative">
            {STEPS.map(({ num, Icon, title, desc }, idx) => (
              <li
                key={num}
                data-testid={`how-step-${idx + 1}`}
                className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-6 sm:p-7 ring-1 ring-white/10 hover:ring-brand-green-light/50 transition-all duration-300"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-2xl bg-brand-green text-white flex items-center justify-center font-bold text-lg shadow-lg shadow-brand-green/30">
                    <Icon size={22} />
                  </div>
                  <span className="text-3xl font-bold text-white/20" style={{ fontFamily: 'Poppins, sans-serif' }}>{num}</span>
                </div>
                <h3 className="text-base sm:text-lg font-semibold mb-1.5">{title}</h3>
                <p className="text-sm text-white/75 leading-relaxed">{desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
